export const ISM_OWNER = "0xd1C8567a16c3bA38aD872d5E631928f889315563" as const;

export const POLYGON_AMOY_CHAIN_ID = 80002;
export const POLYGON_AMOY_HEX = "0x13882" as const;

export const CHAIN_NAME = "Polygon Amoy (Testnet)";
export const CHAIN_CURRENCY = "MATIC";
export const CHAIN_EXPLORER = "https://amoy.polygonscan.com";

export const TOKEN_ADDRESSES = {
  GLO:  (import.meta.env.VITE_GLO_CONTRACT_ADDRESS  ?? "") as `0x${string}`,
  HALO: (import.meta.env.VITE_HALO_CONTRACT_ADDRESS ?? "") as `0x${string}`,
} as const;

export const ERC20_BALANCE_OF = "0x70a08231" as const;
